
import React, { Component } from 'react';import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from 'data/categories/actions';


import {Card, CardTitle} from 'material-ui/Card';

const style = {
  width: 300,
  margin: 10,
  cursor: "pointer",
}

class CategoryItem extends Component {

  
  static contextTypes = {
    router: PropTypes.object
  };

  handleClick = (e) => {
    this.context.router.history.push("/kanal/"+this.props.id);
  }

  render() {
    return (
      <Card className="Card" style={style} onClick={this.handleClick}>

        <div className="Card_themeimage" >
          <img  alt="" src={this.props.category.themeimageUrl} />
          <div className="Card_themeimage_overlay" ></div>
        </div>
        
        <CardTitle title={this.props.category.name} />
        
        <div className="CardText">
          {this.props.category.targetgroup}
        </div>
      </Card>
    );
  }
}

export default connect(null, actions)(CategoryItem);



// WEBPACK FOOTER //
// ./src/pages/channels/CategoryItem.jsx